import { useContext } from 'react'

import { TmapLogContext } from './TmapLogContextProvider'

export function useTmapLogContext() {
  return useContext(TmapLogContext)
}
